import { IUser } from "@modules/auth/interfaces/user";

export function getUser(): IUser {
    if(typeof localStorage !== 'undefined') {
       return JSON.parse(localStorage.getItem('user')!)
    }
    else return {} as IUser
}